import { render, staticRenderFns } from "./AlertManager.vue?vue&type=template&id=f5f6377c&scoped=true"
import script from "./AlertManager.vue?vue&type=script&lang=js"
export * from "./AlertManager.vue?vue&type=script&lang=js"
import style0 from "./AlertManager.vue?vue&type=style&index=0&id=f5f6377c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f6377c",
  null
  
)

export default component.exports